<div class="ui-select-container dropdown"
     [ngClass]="dropdownClasses"
     #mainElement>
  <div class="ui-select-match text-left" [ngClass]="{'input-disabled': readOnly}">
        <span tabindex="-1"
              [ngClass]="{buttonClasses: true, 'input-disabled': readOnly}"
              class="btn btn-default btn-secondary form-control ui-select-toggle"
              (click)="toggleOpen($event, dropdown)"
              [attr.data-hidden]="open"
              style="outline: 0;">
          <span *ngIf="!displayValue" class="ui-select-placeholder text-muted text-left">
            {{ placeholder }}
          </span>
          <span *ngIf="displayValue" class="ui-select-match-text pull-left text-left">
            {{ displayValue | translate }}
          </span>
          <button
            type="button"
            title="Remove Value"
            [attr.test-id]="'remove-value-btn'"
            *ngIf="allowClear && value && !readOnly"
            class="btn btn-xs text-right pos-abt remove-option-btn"
            (click)="removeOption()">
           <i aria-hidden="true" class="fa fa-light fa-times p-t-sm">
             <span aria-hidden="true" class="sr-only">Remove Value</span>
           </i>
          </button>
          <i aria-hidden="true" class="dropdown-toggle text-right"></i>
          <i aria-hidden="true" class="caret pull-right"></i>
        </span>
  </div>
  <input #filterInput
         class="form-control ui-select-search"
         type="text"
         [(ngModel)]="inputValue"
         (ngModelChange)="updatePosition(dropdown)"
         [attr.data-hidden]="!open">
</div>
<div tabindex="0"
     class="ui-select-container dropdown pos-abt"
     [ngClass]="dropdownClasses"
     style="height: 0;">
  <div class="dropdown-menu"
       [attr.data-hidden]="!open"
       [ngClass]="menuClasses"
       [style.left]="dropDownLeft"
       #dropdown>
    <div class="p-a-lg text-center" *ngIf="loading">
      <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
    </div>
    <gp-tree-select-node *ngFor="let node of tree | sortByTranslations:
                        triggerSortByTranslationPipe :['text'] | async"
                         [node]="node"
                         [attr.data-hidden]="!node.visible || isFiltered(node)"
                         [selectFn]="selectFn"
                         [isFiltered]="isFiltered"
                         [expanded]="expandRoots"
                         [triggerSortByTranslationPipe]="triggerSortByTranslationPipe"
                         (isNodeToggle)="updatePosition(dropdown)"
                         [inputValue]="inputValue">
    </gp-tree-select-node>
  </div>
</div>
